import { usePendo } from 'contexts/PendoContext';
import { useCallback } from 'react';

export type ChatbotPendoEvent =
    | { type: 'Initialized' }
    | { type: 'Dismissed' }
    | { type: 'Regenerate'; query: string }
    | {
          type: 'Feedback Submitted';
          feedback: 'positive' | 'negative';
      }
    | { type: 'Feedback Cancelled' }
    | { type: 'Query'; query: string }
    | { type: 'Reset' }
    | { type: 'Expanded' }
    | { type: 'Collapsed' };

export function usePendoTrackChatbot() {
    const pendo = usePendo();

    return useCallback(
        ({ type, ...rest }: ChatbotPendoEvent) => {
            pendo.track(`KCFchat ${type}`, rest);
        },
        [pendo]
    );
}
